import { FormState } from "./types";

export const SELECT_STYLE = `appearance-none rounded-md border bg-white pr-9 pl-3 text-slate-800 ring-0 outline-none focus:ring-4 disabled:bg-slate-100`;

// Shared height variants for Select and Input, mirroring the Button size system
// (button--md / button--sm). `md` is the form-field default (unchanged: py-2);
// `sm` is an EXPLICIT height (h-8) matching button--sm so a <select>/<input>
// lines up pixel-for-pixel with a <button> — padding parity alone doesn't,
// because native control boxes differ in intrinsic height. TextArea/Editor share
// FIELD_STYLE and re-apply `md` directly since they have no variant prop.
export const CONTROL_SIZE_STYLE = {
  md: `py-2`,
  // py-0 overrides the @tailwindcss/forms 0.5rem padding so the h-8 box has full
  // vertical room; leading-none keeps the inherited 24px line-height from clipping
  // a <select>'s text. Together: text centers cleanly without clipping cross-browser.
  // `sm` controls live in toolbars, so they wear the quiet pill.
  sm: `h-8 py-0 text-[13px] leading-none rounded-full! border-transparent! shadow-pill`,
};

export const SELECT_STATE_STYLE = {
  [FormState.Default]: `border-slate-200 focus:border-indigo-500 focus:ring-indigo-300/50`,
  [FormState.Valid]: `border-emerald-500 ring-emerald-300`,
  [FormState.Error]: `border-rose-500 ring-rose-300`,
};

export const SELECT_PLAIN_STYLE = `border-none bg-white ring-0 hover:bg-slate-100 focus:border-none focus:ring-0`;

export const FIELD_STYLE = `block w-full rounded-md border px-3 text-slate-800 ring-0 transition outline-none placeholder:text-slate-400 focus:ring-4 disabled:bg-slate-100 disabled:text-slate-400`;

export const FIELD_STATE_STYLE = {
  [FormState.Default]: `border-slate-200 focus:border-indigo-500 focus:ring-indigo-300/50`,
  [FormState.Valid]: `border-emerald-500 ring-emerald-300 focus:border-emerald-500 focus:ring-emerald-300/50`,
  [FormState.Error]: `border-rose-500 ring-rose-300 focus:border-rose-500 focus:ring-rose-300/50`,
};

export const FIELD_FILE_STYLE = `file:-my-2 file:mr-3 file:-ml-3 file:border-none file:bg-slate-100 file:px-3 file:py-2`;
